import styled from 'styled-components';
import { WithDirection } from '@jjj/components';
import { palette } from 'styled-theme';

const SelectAllTooltipStyles = styled.div`
  font-size: 14px;
  text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};

  .actions-header {
    color: ${palette('grayscale', 0)};
    font-weight: 600;
  }

  ul {
    margin-top: 6px;

    li {
      line-height: 30px;
      button span {
        color: ${palette('secondary', 0)};
        font-weight: normal;
      }
    }
  }

  .ant-divider-horizontal {
    margin: 0;
  }
`;

const SelectSubsectionStyles = styled.div`
  padding: 16px 21px;
`;

const SpinWrapperStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MissingActionsContainerStyles = styled.div`
  margin-top: 6px;
`;

const SelectAllTooltip = WithDirection(SelectAllTooltipStyles);
const SpinWrapper = WithDirection(SpinWrapperStyles);
const SelectSubsection = WithDirection(SelectSubsectionStyles);
const MissingActionsContainer = WithDirection(MissingActionsContainerStyles);

export { SelectAllTooltip, SpinWrapper, SelectSubsection, MissingActionsContainer };
